import { Box } from '@mui/material'
import ManageWebApi from 'api/application/manageWeb'
import { ReviewProps, ReviewSortProps } from 'api/application/manageWeb-interface'
import StarActive from 'assets/icon/starActive'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import CardDraggableList from 'new-components/card/card-list'
import AlertModal from 'new-components/modal/alert-modal'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type ReviewListProps = {
    dataList: any
    onEdit: (status: boolean, item?: any) => void
    statusDel: boolean
    reLoad: () => void
}

const ReviewList = (props: ReviewListProps) => {
    const { t } = useTranslation()
    const t_REVIEW = "MANAGE_WEB.REVIEW"
    const [isDragging, setIsDragging] = useState<boolean>(false)
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [id, setId] = useState(0)
    const [status, setStatus] = useState('')
    const [subject, setSubject] = useState('')


    const renderStarScore = (score: number) => {
        const newEmptyArray = Array(5).fill(null);
        const renderStar = newEmptyArray.map((item: any, index: number) => (
            <StarActive key={index} stroke='#F6E331' fill={score < index + 1 ? 'transparent' : '#F6E331'} />
        ))
        return renderStar
    }

    const onDragStart = (result: any) => {
        setIsDragging(true)
    }

    const onDragEnd = async (result: any) => {
        if (!result.destination) {
            setIsDragging(false)
            return;
        }
        const { source, destination } = result;
        const data = props?.dataList
        const [removed] = data.splice(source.index, 1);
        data.splice(destination.index, 0, removed);

        const newData: ReviewSortProps[] = data.map((item: any, index: number) => {
            return { reviewId: item.reviewId, sorting: index + 1 }
        })
        await ManageWebApi.sortReview(newData).finally(() => {
            setIsDragging(false)
            props.reLoad()
        })
    }

    const onSaveStatus = async (status: 'ACTIVE' | 'INACTIVE', data: any) => {
        const id = data?.reviewId || 0
        const newPayload: ReviewProps = { ...data, status: status }
        if (id !== 0) {
            const res = await ManageWebApi.updateReview(id, newPayload)
            if (res === "pass") {
                setIsOpenAlertModal(false)
                notiSuccess(t(`${t_REVIEW}.SAVE_STATUS`))
                props.reLoad()
            } else {
                setIsOpenAlertModal(false)
                notiError(t(`${t_REVIEW}.SAVE_ERROR`))
            }
        } else {
            setIsOpenAlertModal(false)
            notiError(t(`${t_REVIEW}.SAVE_ERROR`))
        }
    }

    const onDelete = () => {
        if (id !== 0) {
            ManageWebApi.delReview(id).then((resp) => {
                if (resp === "pass") {
                    setIsOpenAlertModal(false)
                    notiSuccess(t(`MANAGE_WEB.REVIEW.DEL_SUC`))
                    props.reLoad()
                } else {
                    setIsOpenAlertModal(false)
                    notiError(t(`MANAGE_WEB.REVIEW.SAVE_ERROR`))
                }
            })
        } else {
            setIsOpenAlertModal(false)
            notiError(t(`MANAGE_WEB.REVIEW.SAVE_ERROR`))
        }
    }


    return (
        <Box >
            <AlertModal
                isOpen={isOpenAlertModal}
                title={status !== '' ? t(t_REVIEW + '.NOTI_CHANGE_STATUS') : t(`MANAGE_WEB.TITLE_DEL`)}
                message={status !== '' ? t(`${t_REVIEW}.ALERT.CONFIRM_STATUS_`, {
                    subject: subject || '-',
                    status: t(`STATUS.${status}`)
                }) : t('MANAGE_WEB.REVIEW.NOTI_DEL')}
                type={status !== '' ? 'warning' : 'error'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{
                    onClick: () => {
                        if (status !== '') {
                            const item = props.dataList.find((i: any) => i.reviewId === id)
                            onSaveStatus(status as 'ACTIVE' | 'INACTIVE', item)
                        } else {
                            onDelete()
                        }
                    },
                    title: t('BUTTON.SUBMIT')
                }}
            />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: {
                    xs: '73vh',
                    sm: '73vh',
                    md: '70vh',
                    xl: '72vh'
                },
                overflowY: 'auto',
            }}>
                <CardDraggableList
                    data={props.dataList}
                    isDragging={isDragging}
                    onDragEnd={onDragEnd}
                    onDragStart={onDragStart}
                    idField="reviewId"
                    topicField="review"
                    onActive={(e) => {
                        setId(e.reviewId)
                        setIsOpenAlertModal(true)
                        setStatus("ACTIVE")
                        setSubject(e.topic)
                    }
                    }
                    onInActive={(e) => {
                        setId(e.reviewId)
                        setIsOpenAlertModal(true)
                        setStatus("INACTIVE")
                        setSubject(e.topic)
                    }
                    }
                    onEdit={(status, item) => props.onEdit(status, item)}
                    onDelete={(e) => {
                        setId(e.reviewId)
                        setIsOpenAlertModal(true)
                    }}
                />
            </Box>
        </Box>
    )
}

export default ReviewList